import React from 'react';
import UnitSectionsListFunctional from './components/unit-sections-list-functional';
import './unit-sections.scss';

const UnitSectionsList = () => {
	return <UnitSectionsListFunctional />;
};

export default UnitSectionsList;
